import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApi } from '../useApi';
import { toast } from '../../../components/Toast';
import { keys } from './frameCompany.keys';

export function useArchiveFrameCompany(companyId: string) {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const mutationFn = async (archive: boolean) => {
    const api = await getApi();

    if (archive) {
      const res = await api.frameCompanyInactivateFrame(companyId);
      return res.data;
    } else {
      const res = await api.frameCompanyActivateFrame(companyId);
      return res.data;
    }
  };

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: keys.all });
  };

  const onError = () => {
    toast.error('Något gick fel');
  };

  const mutation = useMutation({
    mutationFn,
    onSuccess,
    onError,
  });

  return mutation;
}
